// src/App.tsx
import React from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { lightTheme } from './theme';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from './pages/Home';
import DrawerAppBar from './components/NavBar';
import Projects from './pages/Projects';
import Blog from './pages/Blog';
import NotFound from './pages/NotFound';
import BlogPost from './pages/BlogPost';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={lightTheme}>
      <Router>
        <CssBaseline />
        <DrawerAppBar />
        <div>
          <Box component="main" sx={{ flexGrow: 1, mt: '64px' }}>
            <Routes>
              <Route path="/" Component={Home} />
              <Route path="/home" Component={Home} />
              <Route path="/projects" Component={Projects} />
              <Route path="/blog" Component={Blog} />
              <Route path="*" Component={NotFound} />
              <Route path="/blog/:BlogId/:id" Component={BlogPost} />
            </Routes>
          </Box>
        </div>
      </Router>
    </ThemeProvider>
  );
};

export default App;
